import ProviderBotContainer from './provider-bot-container';

export default ProviderBotContainer;
